export const environment = {
  production: false,
  demo: true,
  isProduction: false,
  apiUrl: 'https://api.demo.portal.frauddeflect.net/api/v1/',
  domain: 'https://demo.portal.frauddeflect.net/en-us',
  demoDashboardFdId: '0857ac00-4e45-4298-a179-aa5938b875a7',
  dashboardFdId: 'a7a7b51c-9dca-4e5d-9da1-673fdc004199',
  dashboardPartnerId: '1dd497ff-97fc-4191-8637-0e7967f38b14',
  dashboard: '53c3b55a-26f1-41b5-82e7-9a7d1beecaea',
  requestPermissionChange: 'https://forms.gle/Ft27FfNXLd6f3gR4A',
  savingsCalculatorDashboardId: '783996dd-ea44-41e9-a490-37701c103c54'
}
